import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import QuestionText from './QuestionText';
import DropDown from 'components/elements/atoms/DropDown/DropDown';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';

function SchoolPickerQuestion({
  question,
  onChange,
  model,
  actions,
  shouldDisabled,
}) {
  const [schools, setSchools] = useState([]);
  const value = model[question.variable];

  useEffect(() => {
    actions.getSchools().then(({ schools }) => setSchools(schools));
  }, []);

  function renderText() {
    return <QuestionText question={question} />;
  }

  const containerClassNames = classNames('question', {
    disabled: shouldDisabled ? shouldDisabled(question) : false,
  });

  const schoolOptions = schools
    .map((s) => ({
      label: `${s.name} - ${[s.city, s.state, s.country]
        .filter((i) => !!i)
        .join(', ')}`,
      value: s._id,
    }))
    .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1));
  return (
    <div className={containerClassNames}>
      {renderText()}
      <DropDown
        value={value}
        options={schoolOptions}
        onChange={(value) => {
          onChange(value, question.variable);

          if (question.schoolNameVariable) {
            onChange(value.label, question.schoolNameVariable);
          }

          if (question.schoolLocationVariable) {
            const school = schools.find((i) => i._id === value.value);

            if (school && school.city && school.state && school.country) {
              onChange(
                [
                  {
                    city: school.city,
                    state: school.state,
                    country: school.country,
                  },
                ],
                question.schoolLocationVariable,
              );
            }
          }
        }}
        className="mb-0"
        isDisabled={shouldDisabled ? shouldDisabled(question) : false}
        controlStyle={{ backgroundColor: 'transparent' }}
      />
    </div>
  );
}

export default connect(
  () => {
    return {};
  },
  (dispatch) => {
    return { actions: bindActionCreators(Actions, dispatch) };
  },
)(SchoolPickerQuestion);
